import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { deleteCustomfieldAction } from 'src/redux/actions/customfieldActions';

const DeleteCustomfieldDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteCustomfield]) {
        return state.dialog[DIALOGS.deleteCustomfield];
      }
      return { opened: false, payload: null };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteCustomfield }));
  };

  const handleOk = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteCustomfield }));
    dispatch(deleteCustomfieldAction(payload));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-customfields"
      open={opened}>
      <DialogTitle id="deleting-customfields">{t(lang, 'menus.deleting_customfields')}</DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.deleting_customfields_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.no')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'misc.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCustomfieldDialog;
